<template>
  <div>
    <GenericPage>
      <template slot="breadcrumb-items">
        <li class="active bold">Comisiones</li>
      </template>
      <template slot="title">
        Consulta los costos y comisiones.
      </template>
      <template slot="body">
        <CPArea1 />
        <CPAccordion />
      </template>
    </GenericPage>
  </div>
</template>

<script>
import CPArea1 from "@components/comissions-page/CPArea1";
import CPAccordion from "@components/comissions-page/CPInvestorAccordion";
import GenericPage from "./new-portal-views/GenericPage.vue"
// import CPInvestors from "@components/comissions-page/CPInvestors";
// import CPApplicants from "@components/comissions-page/CPApplicants";
// import CPSuppliers from "@components/comissions-page/CPSuppliers";
export default {
  name: "ComissionsPage",
  components: {
    CPAccordion,
    CPArea1,
    GenericPage
  },
}
</script>
